/**
 * Which pages keep the player mounted behind them (job #254, Tom 2026-10-16:
 * "returning to the player must NEVER refetch or rebuild the course; it is
 * already loaded").
 *
 * The player route used to unmount on every trip away, so Back from the Brain
 * rebuilt the whole lesson: the bundle, the round map, the cycles, the script,
 * behind a spinning play button. Now the player is cached by RoutedView's
 * KeepAlive while the learner is on the player itself or on a learner page
 * (the Brain, or any page carrying the player's bottom nav), and released the
 * moment they go anywhere else, so a teacher's dashboard or an admin view
 * never holds a hidden player.
 */
import type { RouteLocationNormalizedLoaded } from 'vue-router'

/** The kept component, by the name Vue infers from PlayerContainer.vue. */
export const KEPT_PLAYER = 'PlayerContainer'

type RouteLike = Pick<RouteLocationNormalizedLoaded, 'name' | 'matched'>

export function keepsPlayerAlive(route: RouteLike): boolean {
  if (route.name === 'player' || route.name === 'learner-brain') return true
  return route.matched.some((r) => r.meta?.learnerNav)
}

/** KeepAlive's `include`: the player while it may be returned to, else nothing. */
export function playerKeepAliveInclude(route: RouteLike): string[] {
  return keepsPlayerAlive(route) ? [KEPT_PLAYER] : []
}
